import { createAsyncThunk } from "@reduxjs/toolkit";
import { URL_LAB_DEPT } from "../../config/connString";
import useAxios from "../../utils/useAxios";
const deleteLabDepartment = createAsyncThunk(
  "labDepartments/delete-lab-department",
  async (data) => {
    try {
      const api = useAxios();
      const response = await api.delete(URL_LAB_DEPT + "/" + data);
      return response.data;
    } catch (error) {
      return error;
    }
  }
);

export { deleteLabDepartment };
